'use client';
import Notifications from './Notifications';

export default function NotificationsBoundary({ children }: { children: React.ReactNode }) {
  return (
    <div className="w-full h-screen relative">
      {children}
      <Notifications />
    </div>
  );
}
